import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "build__footer-wrapper" }
const _hoisted_2 = { class: "build__footer-desc" }
const _hoisted_3 = { class: "build__author-name" }
const _hoisted_4 = { class: "build__footer-dates-wrapper" }
const _hoisted_5 = { class: "build__footer-date-item" }
const _hoisted_6 = { class: "build__date" }
const _hoisted_7 = {
  key: 0,
  class: "build__footer-date-item"
}
const _hoisted_8 = { class: "build__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_IconPen = _resolveComponent("IconPen")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserAvatar, {
      "photo-u-r-l": _ctx.photoURL,
      "display-name": _ctx.displayName,
      "email-hash": _ctx.emailHash,
      "avatar-provider": _ctx.avatarProvider,
      class: "build__avatar"
    }, null, 8, ["photo-u-r-l", "display-name", "email-hash", "avatar-provider"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.displayName || 'Пользователь не найден'), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(new Date(_ctx.createdAt.seconds * 1000).toLocaleDateString() || '—'), 1)
        ]),
        (_ctx.updatedAt && !_ctx.isSameDay(_ctx.updatedAt, _ctx.createdAt))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_IconBase, {
                width: 12,
                height: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconPen)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_8, _toDisplayString(new Date(_ctx.updatedAt.seconds * 1000).toLocaleDateString()), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}